import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  SyncOutlined,
} from '@ant-design/icons';

interface EntityStatusTagProps {
  kind: 'transfer' | 'withdrawal';
  status: string;
  size?: 'small' | 'default';
}

/**
 * S-H5: Consistent status tag component for transfers and withdrawals
 * Standardized colors and icons across Treasury UI
 */
const EntityStatusTag: React.FC<EntityStatusTagProps> = ({ kind, status, size = 'default' }) => {
  const getTransferConfig = (status: string) => {
    const configs: Record<string, { color: string; icon: React.ReactNode }> = {
      pending: { color: 'orange', icon: <ClockCircleOutlined /> },
      processing: { color: 'blue', icon: <SyncOutlined spin /> },
      succeeded: { color: 'green', icon: <CheckCircleOutlined /> },
      failed: { color: 'red', icon: <CloseCircleOutlined /> },
      cancelled: { color: 'default', icon: <CloseCircleOutlined /> },
      returned: { color: 'purple', icon: <WarningOutlined /> },
    };
    return configs[status] || { color: 'default', icon: null };
  };

  const getWithdrawalConfig = (status: string) => {
    const configs: Record<string, { color: string; icon: React.ReactNode }> = {
      pending: { color: 'orange', icon: <ClockCircleOutlined /> },
      approved: { color: 'blue', icon: <CheckCircleOutlined /> },
      rejected: { color: 'red', icon: <CloseCircleOutlined /> },
      done: { color: 'green', icon: <CheckCircleOutlined /> },
      canceled: { color: 'default', icon: <CloseCircleOutlined /> },
      cancelled: { color: 'default', icon: <CloseCircleOutlined /> },
      partially_paid: { color: 'cyan', icon: <SyncOutlined /> },
    };
    return configs[status] || { color: 'default', icon: null };
  };

  const config = kind === 'transfer' ? getTransferConfig(status) : getWithdrawalConfig(status);
  const fontSize = size === 'small' ? 11 : 14;

  return (
    <Tag color={config.color} icon={config.icon} style={{ fontSize }}>
      {status.toUpperCase().replace(/_/g, ' ')}
    </Tag>
  );
};

export default EntityStatusTag;
